module.exports = __webpack_public_path__ + "media/old_images/icon-chevron-down-fbe61a69.svg";